import { render, staticRenderFns } from "./EditUnit.vue?vue&type=template&id=0c06db51"
import script from "./EditUnit.vue?vue&type=script&lang=js"
export * from "./EditUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports